type Falsy = false | undefined | null | '' | 0;

export const filterFalsy = <T>(arr: T[]) =>
	arr.filter(Boolean) as Exclude<T, Falsy>[];

export default filterFalsy;
